import React from 'react'
import { withRouter } from "react-router-dom"
import { withStyles } from '@material-ui/core/styles'

import Footer from '../Footer'

import Container from '@material-ui/core/Container'

const LoginPageStyle = theme => ({
    root: {
        height: '100%'
    },
    app: {
        height: '100vh',
        backgroundImage: "url('/images/login-background.png')",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        //background: "url('/images/login-background.png') no-repeat",
    },
    appContainer: {
        paddingTop: '10%',
        paddingBottom: '10%',
    },
})

class Login extends React.Component {
    render() {
        const { classes } = this.props

        const appStyle = this.props.hasOwnProperty('appStyle')
            ? this.props.appStyle
            : {}

        return <main id="Login" className={classes.root}>
            <div id="App" className={classes.app} style={appStyle}>
                <Container maxWidth="sm" className={classes.appContainer}>
                    {this.props.children}
                </Container>
            </div>
            <Footer containerSize="lg" textAlign="center" itemXs />
        </main>
    }
}

export default withRouter(withStyles(LoginPageStyle)(Login))